﻿export enum ValidationMessageType {
    Error,
    Warning,
    Info,
    Ok,
}
